import { AnalyticsHours } from "@stories/pages/Contractor/Analytics/AnalyticsHours";

export const AnalyticsHoursView = () => {
  return <AnalyticsHours />;
};
